import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfirmationLabTestService } from './confirmation-lab-test.service';
import { BaseConsultationComponent } from '../base-consultation/base-consultation.component';
import { DialogService } from '../../../shared/services/dialog.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsultationProcessService } from '../consultation-process.service';
import { ConsultationStep } from '../../../models/consultation/consultation.model';
import { NewLabTestPopupComponent } from './new-labtest-popup.component';
import { MdCheckboxChange } from '@angular/material';
// import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { LabTestDataService } from '../../master-data/lab-test-data/lab-test-data.service';
import * as moment from 'moment';

@Component({
    templateUrl: 'confirmation-lab-tests.component.html',
    providers: [ConfirmationLabTestService, LabTestDataService],
    styleUrls: ['confirmation-lab-test.componenet.scss']
})

export class ConfirmationLabTestComponent extends BaseConsultationComponent implements OnInit, OnDestroy {
    public labTestData = [];
    // public inClinicTestData = [];
    public appConstants = AppConstants;

    public labtestTestResultData = [];

    public listCentreLabtestIds = [];
    constructor(public dialogService: DialogService,
        public consultationProcessService: ConsultationProcessService,
        public router: Router,
        public activeRouter: ActivatedRoute,
        // private labTestService: LabTestDataService,
        public confirmationLabTestService: ConfirmationLabTestService) {
        super(dialogService, consultationProcessService, router, activeRouter, ConsultationStep.ConfirmLabTests);
    }

    ngOnInit() {


        this.confirmationLabTestService.getLabTestList(this.filterParam.id).subscribe(
            (result) => {
                if (result) {
                    var data = result.json();
                    // this.labTestData = result.json();
                    if (data) {
                        if (data.length > 0) {
                            data.forEach(x => {
                                this.listCentreLabtestIds.push(x.centreLabtestId);
                            });

                            this.labTestData = data;
                            // this.labTestData = data.filter(d => d.inClinicTest == false);
                            // this.inClinicTestData = data.filter(d => d.inClinicTest == true);
                        }
                    }
                }
            }
        );
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }

    onOpenNewLabTestDialog() {
        const data = {
            consultationId: this.filterParam.id,
            listCentreLabtestIds: this.listCentreLabtestIds
        };

        this.dialogService.openComponentDialog(NewLabTestPopupComponent, data, {
            'width': '450px', position: {
                top: this.getTopPosition() + 'px'
            }
        }).subscribe(result => {
            if (result) {
                result.forEach(element => {
                    if (this.labTestData.findIndex(l => l.centreLabtestId === element.centreLabtestId) < 0) {

                        this.labTestData.push(element);
                        this.listCentreLabtestIds.push(element.centreLabtestId);
                    }
                });
            }
        });
    }


    /**
    * save data when user click on next/prev/other step
    */
    submitData() {
        //update order
        for (let i = 0; i < this.labTestData.length; i++) {
            this.labTestData[i].order = i;

            // add SampleCollectionClientTime
            if (this.labTestData[i].sampleCollectionTime) {
                this.labTestData[i].SampleCollectionClientTime = moment(this.labTestData[i].SampleCollectionClientTime).format(this.appConstants.dateConfig.colectionClientTime)+'Z';
            }
        }


        this.confirmationLabTestService.confirmationLabTest(this.filterParam.id, this.labTestData, this.isMoveNextStep).subscribe(
            (result) => {
                this.navigateAction();
            }
        );

    }


    /**
    * over write redirect to another step in consultation
    */
    navigateAction() {
        if (this.isMoveNextStep) {
            this.router.navigate([this.navigateUrl]);
        } else if (this.filterParam.patientId) {
            this.router.navigate([this.navigateUrl, this.filterParam.id, this.filterParam.patientId]);
        } else {
            this.router.navigate([this.navigateUrl, this.filterParam.id]);
        }
    }

    onConfirmLabTest(item, event: MdCheckboxChange) {
        item.isChecked = event.checked;

        if (item.isChecked) {
            this.confirmationLabTestService.getPatientSampleInformation(this.filterParam.id).subscribe(
                (result) => {
                    if (result) {
                        var data = result.json();
                        if (data) {
                            var currentDatetime = new Date();

                            let times = '';
                            if (data.quantityQuickTestInDay < 10) {
                                times = '0' + (data.quantityQuickTestInDay + 1);
                            }
                            else {
                                times = (data.quantityQuickTestInDay + 1);
                            }

                            var month = currentDatetime.getMonth() + 1;
                            let strMonth = '';
                            if (month < 10) {
                                strMonth = '0' + month;
                            }
                            else {
                                strMonth = month.toString();
                            }

                            let strDay = '';
                            if (currentDatetime.getDate() < 10) {
                                strDay = '0' + currentDatetime.getDate();
                            }
                            else {
                                strDay = currentDatetime.getDate().toString();
                            }

                            item.sampleID = data.patientRef + "-" + currentDatetime.getFullYear() + strMonth + strDay + "-" + times;
                            item.sampleCollectionTime = new Date();
                        }
                    }
                }
            );
        }
        // getPatientSampleInformation
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/confirmation-lab-tests/confirmation-lab-tests.component.ts